import {
    NinchatActionType,
    NinchatUpdateIdentityAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateIdentity = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateIdentityAction}`,
    async (arg: NinchatActionParams<NinchatUpdateIdentityAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateIdentityAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
